import { Accordion, FlexContainer, Separator, Spinner, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { useGetPlanFlexInfo } from 'Containers/Result/hooks';
import { parsePriceFormat } from 'Containers/Result/components/PaymentLater/utils';
import { FRONT_PLANS } from 'Constants/plans';
import * as Styled from './styles';

export const PayLaterInfo = ({ result }: { result: number }): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const { data, isLoading } = useGetPlanFlexInfo();
  if (isLoading || !data) {
    return (
      <FlexContainer align="center" justify="center">
        <Spinner size="M" align="center" justify="center" />
      </FlexContainer>
    );
  }
  const amountRecovered = YayoyakiFormatter.formatAmountMxn(
    Math.abs(result) - Number(parsePriceFormat(data?.discountedPrice || data?.price, true))
  );
  return (
    <>
      <Text type="paragraphs" size="M_L_S" color="dark">
        {t('ReviewForm.toReturn.devolution')}
      </Text>
      <Accordion testID="accordion-paylater">
        <Text type="paragraphs" color="grey" size="S_M_M">
          {amountRecovered}
        </Text>
        <FlexContainer direction="column" gap="dimension_16">
          <Styled.Container>
            <Text type="paragraphs" color="dark" size="S_S_S">
              {t('ReviewForm.amount')}
            </Text>
            <Styled.Label type="paragraphs" color="dark" size="S_S_S">
              {YayoyakiFormatter.formatAmountMxn(Math.abs(result))}
            </Styled.Label>
          </Styled.Container>
          <Styled.Container>
            <Text type="paragraphs" color="dark" size="S_S_S">
              {t('Filing.plan', { plan: FRONT_PLANS.FLEX })}
            </Text>
            <Styled.Label type="paragraphs" color="dark" size="S_S_S">
              {`- ${parsePriceFormat(data?.price)}`}
            </Styled.Label>
          </Styled.Container>
          {data?.discount?.amountOff && (
            <Styled.Container>
              <Text type="paragraphs" color="dark" size="S_S_S">
                {t('PayLater.discount')}
              </Text>
              <Styled.Label type="paragraphs" color="dark" size="S_S_S">
                {`+ ${parsePriceFormat(data?.discount.amountOff)}`}
              </Styled.Label>
            </Styled.Container>
          )}
          <Separator />
          <Styled.Container>
            <Text type="paragraphs" size="S_L_S" color="dark">
              {t('ReviewForm.toReturn.devolution')}
            </Text>
            <Styled.Label type="paragraphs" color="dark" size="M_XL_S">
              {amountRecovered}
            </Styled.Label>
          </Styled.Container>
        </FlexContainer>
      </Accordion>
    </>
  );
};
